import Portal from '@/directives/portal'

export default {
  name: 'Footer',
  mixins: [],
  components: {
    Terms: () => import(/* webpackChunkName: "Terms" */ '@/components/terms/Terms.vue'),
    Privacy: () => import(/* webpackChunkName: "Privacy" */ '@/components/privacy/Privacy.vue')
  },
  props: {},
  data () {
    return {
      modalOpen: null
    }
  },
  computed: {
  },
  methods: {
    openModal (modal) {
      this.modalOpen = modal
    },
    closeModal () {
      this.modalOpen = false
    }
  },
  directives: {
    Portal
  }
}
